__turbopack_context__.v({
  "checkbox": "OptionFieldInput-module-scss-module__ua5emG__checkbox",
  "checked": "OptionFieldInput-module-scss-module__ua5emG__checked",
  "disabled": "OptionFieldInput-module-scss-module__ua5emG__disabled",
  "empty": "OptionFieldInput-module-scss-module__ua5emG__empty",
  "error": "OptionFieldInput-module-scss-module__ua5emG__error",
  "green": "OptionFieldInput-module-scss-module__ua5emG__green",
  "greenRadio": "OptionFieldInput-module-scss-module__ua5emG__greenRadio",
  "heart": "OptionFieldInput-module-scss-module__ua5emG__heart",
  "indeterminate": "OptionFieldInput-module-scss-module__ua5emG__indeterminate",
  "radio": "OptionFieldInput-module-scss-module__ua5emG__radio",
  "root": "OptionFieldInput-module-scss-module__ua5emG__root",
  "switch": "OptionFieldInput-module-scss-module__ua5emG__switch",
  "thumb": "OptionFieldInput-module-scss-module__ua5emG__thumb",
});
